import * as actions from './resident.actions';
import watch from './resident.operations';
import reducer, { initState } from './resident.reducers';

export { actions, watch, initState };

export default reducer;
